//自定义组件相关路由
export default [
	{
		path: "/:project_id/panel-group/:uid",
		name: "panel-group",
		component: () => import("@/views/panel-group/index.vue"),
	},
];
 